import {
  SKILLBREW_APP_API_BASE_URL,
  SKILLBREW_APP_API_BASE_URL_V2,
  SKILLBREW_BADGES_API_BASE_URL,
  SKILLBREW_PAYMENTS_APP_URL,
} from "./Config";

export const ApiConfig = {
  Login: SKILLBREW_APP_API_BASE_URL + "user/admin/login/",
  Csrf: SKILLBREW_APP_API_BASE_URL + "user/csrf/",
  LoginDetail: SKILLBREW_APP_API_BASE_URL + "user/login/detail/",
  Refresh_Token: SKILLBREW_APP_API_BASE_URL + "user/refresh-token/",
  Logout: SKILLBREW_APP_API_BASE_URL + "user/logout/",
  DeactivateOrganization:
    SKILLBREW_APP_API_BASE_URL + "organization/admin/deactivate/",
  DeactivateBrewUser:
    SKILLBREW_APP_API_BASE_URL + "user/admin/deactivate-user/",
  OrganizationList: SKILLBREW_APP_API_BASE_URL + "organization/admin/list/",
  OrganizationAdminCreate:
    SKILLBREW_APP_API_BASE_URL + "organization/admin/create/",
  UsersList: SKILLBREW_APP_API_BASE_URL + "user/user/list/",
  ContestList: SKILLBREW_APP_API_BASE_URL + "test/test-admin/list/",
  SupportList:
    SKILLBREW_APP_API_BASE_URL + "helpnsupport/admin-contact-us/list/",
  UpdateQueryStaus:
    SKILLBREW_APP_API_BASE_URL + "helpnsupport/contact-us/status-update",
  NewsLetterList: SKILLBREW_APP_API_BASE_URL + "helpnsupport/newsletter/list",
  MeetingSlotsList:
    SKILLBREW_APP_API_BASE_URL + "helpnsupport/meeting-slot/list",
  CreateMeetingSlot:
    SKILLBREW_APP_API_BASE_URL + "helpnsupport/meeting-slot/",
  SaleInquiriesList: SKILLBREW_APP_API_BASE_URL + "helpnsupport/pricing/list/",
  JobCreation: SKILLBREW_APP_API_BASE_URL + "careers/jobs/create/",
  UpdateDemoStatus:
    SKILLBREW_APP_API_BASE_URL + "helpnsupport/meeting-slot/update/status",
  PaymentPlansList: SKILLBREW_PAYMENTS_APP_URL + "admin/plans/",
  PaymentPlanCreate: SKILLBREW_PAYMENTS_APP_URL + "admin/plan/create/",
  PromoCodeList: SKILLBREW_PAYMENTS_APP_URL + "admin/promo-code/list/",
  PromoCodeCreate: SKILLBREW_PAYMENTS_APP_URL + "admin/promo-code/create/",
  EvaluationPromoCodeCreate:
    SKILLBREW_PAYMENTS_APP_URL + "admin/evaluation-promo-code/create/",
  PromoCodeUpdate: SKILLBREW_PAYMENTS_APP_URL + "admin/promo-code/update/",
  EvaluationPromoCodeUpdate:
    SKILLBREW_PAYMENTS_APP_URL + "admin/evaluation-promo-code/update/",
  PromoUsageList: SKILLBREW_PAYMENTS_APP_URL + "admin/promo-code/usage/",
  OrganizationDetails:
    SKILLBREW_APP_API_BASE_URL + "organization/admin/details/",
  OrgMembersAdminList:
    SKILLBREW_APP_API_BASE_URL + "organization/admin/members/",
  AccountManagerAdmin:
    SKILLBREW_APP_API_BASE_URL + "organization/admin/account-manager/",
  OrganizationPaymentDetails:
    SKILLBREW_PAYMENTS_APP_URL + "admin/orgs/payment-details/",
  ActivateEvaluationPromo:
    SKILLBREW_PAYMENTS_APP_URL + "admin/evaluation-org-promo/activate/",
  ServiceChargeList: SKILLBREW_PAYMENTS_APP_URL + "admin/service-charge/list/",
  ServiceChargeCreate:
    SKILLBREW_PAYMENTS_APP_URL + "admin/service-charge/create/",
  DLQMessagesList: SKILLBREW_PAYMENTS_APP_URL + "admin/fetch/dlq-messages/",
  JobList: SKILLBREW_APP_API_BASE_URL + "careers/jobs/",
  JobCreate: SKILLBREW_APP_API_BASE_URL + "careers/jobs/create/",
  SkillsList: SKILLBREW_APP_API_BASE_URL + "userprofile/all/skills/",
  SkillsAdminList:
    SKILLBREW_APP_API_BASE_URL + "userprofile/list/skills/admin/",
  SkillsManualUpload:
    SKILLBREW_APP_API_BASE_URL + "userprofile/upload/skills/list/",
  SkillsCsvUpload:
    SKILLBREW_APP_API_BASE_URL + "userprofile/upload/skills/csv/",
  SkillsBulkVerify:
    SKILLBREW_APP_API_BASE_URL + "userprofile/bulk/verify/skills/",
  JobDetail: SKILLBREW_APP_API_BASE_URL + "careers/jobs/",
  JobApplicantsList: SKILLBREW_APP_API_BASE_URL + "careers/jobs/applications/",
  CouponList: SKILLBREW_PAYMENTS_APP_URL + "admin/coupons/list/",
  CouponUsageList: SKILLBREW_PAYMENTS_APP_URL + "admin/coupon/usage/",
  CouponUpdate: SKILLBREW_PAYMENTS_APP_URL + "admin/coupon/update/",
  CouponCreate: SKILLBREW_PAYMENTS_APP_URL + "admin/coupon/create/",
  PaymentPlanDetail: SKILLBREW_PAYMENTS_APP_URL + "admin/plan/",
  PaymentPlanUpdate: SKILLBREW_PAYMENTS_APP_URL + "admin/plan/update/",
  PlanDiscountCreate:
    SKILLBREW_PAYMENTS_APP_URL + "admin/plan-discount/create/",
  PlanDiscountUpdate:
    SKILLBREW_PAYMENTS_APP_URL + "admin/plan-discount/update/",
  BadgeList: SKILLBREW_BADGES_API_BASE_URL + "v1/badge/list/",
  BadgeCreate: SKILLBREW_BADGES_API_BASE_URL + "v1/badge/badge-create/",
  BadgeUpdate: SKILLBREW_BADGES_API_BASE_URL + "v1/badge/",
  BadgeDelete: SKILLBREW_BADGES_API_BASE_URL + "v1/badge/",
  BadgeUploadPresigned:
    SKILLBREW_BADGES_API_BASE_URL + "v1/upload_s3/post/presigned/",
  CertificateList: SKILLBREW_BADGES_API_BASE_URL + "v1/certificate/list/",
  CertificateCreate:
    SKILLBREW_BADGES_API_BASE_URL + "v1/certificate/certificate-create/",
  CertificateUpdate: SKILLBREW_BADGES_API_BASE_URL + "v1/certificate/",
  CertificateDelete: SKILLBREW_BADGES_API_BASE_URL + "v1/certificate/",
  CertificateCriteriaList:
    SKILLBREW_BADGES_API_BASE_URL + "v1/certificate-award-criteria/list/",
  CertificateCriteriaCreate:
    SKILLBREW_BADGES_API_BASE_URL + "v1/certificate-award-criteria/",
  CertificateCriteriaUpdate:
    SKILLBREW_BADGES_API_BASE_URL + "v1/certificate-award-criteria/",
  CertificateCriteriaDelete:
    SKILLBREW_BADGES_API_BASE_URL + "v1/certificate-award-criteria/",
  CertificateCriteriaById:
    SKILLBREW_BADGES_API_BASE_URL + "v1/certificate-award-criteria/",
  VerifyQuestion: SKILLBREW_APP_API_BASE_URL + "questions/",
  PdfExtract: SKILLBREW_APP_API_BASE_URL_V2 + "questions/pdf-extract/",
  BulkCreateMCQ: SKILLBREW_APP_API_BASE_URL_V2 + "questions/bulk-create-mcq/",

  CmsPageList: SKILLBREW_APP_API_BASE_URL + "static_data/pages/list/",
  CmsPageRetrieve: SKILLBREW_APP_API_BASE_URL + "static_data/pages/retrieve/",
  CmsPageCreate: SKILLBREW_APP_API_BASE_URL + "static_data/pages/create/",
  CmsPageUpdate: SKILLBREW_APP_API_BASE_URL + "static_data/pages/update/",
  CmsPagePublish: SKILLBREW_APP_API_BASE_URL + "static_data/pages/publish/",
  CmsPageArchive: SKILLBREW_APP_API_BASE_URL + "static_data/pages/archive/",
  CmsPagePresign: SKILLBREW_APP_API_BASE_URL + "static_data/pages/uploads/presign/",
  // --- SBW-2273 pricing admin (payments service, under /v1/admin) ---
  FeatureCatalogBase: SKILLBREW_PAYMENTS_APP_URL + "v1/admin/feature-catalog/",
  CalculatorPresetBase: SKILLBREW_PAYMENTS_APP_URL + "v1/admin/calculator-presets/",
  TopupPresetBase: SKILLBREW_PAYMENTS_APP_URL + "v1/admin/topup-presets/",
  TopupBonusRuleBase: SKILLBREW_PAYMENTS_APP_URL + "v1/admin/topup-bonus-rules/",
  CurrencyCreditRateBase:
    SKILLBREW_PAYMENTS_APP_URL + "v1/admin/currency-credit-rates/",
  ChargeSyncBase: SKILLBREW_PAYMENTS_APP_URL + "v1/admin/pricing/sync-charges/",
  OrgPricingBase:
    SKILLBREW_PAYMENTS_APP_URL + "v1/admin/org-pricing/",
  ManualCreditGrant: SKILLBREW_PAYMENTS_APP_URL + "admin/manual-payment/issue/",
  EntityTransactions: SKILLBREW_PAYMENTS_APP_URL + "admin/entity/transactions/",
};
